import React, { useState } from 'react';
import ChangeTierModal from 'components/payment/ChangeTierModal.jsx';

// The /dielines-api-pricing button for a monthly Dielines API subscriber: it changes their subscription
// to the plan picked above it, instead of buying a second subscription. `options`
// (DielinesApiPlanChangeOptions#options) are the plans this subscription can move to now; picking any
// other plan (their current one, or one they cannot move to) only explains that.
const ChangeDielinesApiPlanButton = ({ stripe_id, options, scheduled_change_line }) => {
  const [target, setTarget] = useState(null);
  const [hint, setHint] = useState('');

  if (scheduled_change_line) {
    return <p className="plan-choice-current-line">{scheduled_change_line}</p>;
  }

  if (options.length === 0) {
    return (
      <p className="plan-choice-current-line">
        {t('payment.change_dielines_api_plan_not_available')}{' '}
        <a href="/my_subscriptions">{t('payment.manage_subscription')}</a>
      </p>
    );
  }

  const openSelectedPlan = (event) => {
    event.preventDefault();
    const selectedPlanId = document.querySelector('input[name="api_subscription_type"]:checked')?.dataset.planId;
    const option = options.find((candidate) => candidate.plan_id === selectedPlanId);
    if (option) {
      setHint('');
      setTarget(option);
    } else {
      setHint(t('payment.change_dielines_api_plan_pick_another'));
    }
  };

  return (
    <span>
      <center>
        <a className="btn btn-price simple-btn" href="#" onClick={openSelectedPlan}>{t('payment.change_plan_cta')}</a>
      </center>
      {hint && <p className="plan-choice-current-line">{hint}</p>}
      {target && (
        <ChangeTierModal
          targetTierName={target.name}
          direction={target.direction}
          stripeId={stripe_id}
          previewUrl={target.preview_url}
          changeUrl={target.change_url}
          targetData={target.target_data}
          upgradeNote={target.upgrade_note}
          onClose={() => setTarget(null)}
          onSuccess={() => window.location.reload()}
        />
      )}
    </span>
  );
};

export default ChangeDielinesApiPlanButton;
